module.exports = __webpack_public_path__ + "img/arrow-select.18d27dbeddef9968ae162b650d28810d.svg";